import React, { useState } from "react";
import { adminApi } from "../../utils/axiosConfig";
import styled from "styled-components";

// STYLES
const DeleteButton = styled.button`
  background-color: #e53e3e;
  margin-top: 1rem;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-size: 0.95rem;

  &:hover {
    background-color: #c53030;
  }

  &:disabled {
    background-color: #feb2b2;
    cursor: not-allowed;
  }
`;

const ErrorText = styled.p`
  color: #e53e3e;
  margin-top: 0.5rem;
  font-size: 0.9rem;
`;

export default function DeleteCommande({ orderId, refreshOrders }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    if (!window.confirm("Confirmer la suppression ?")) return;

    setLoading(true);
    setError(null);

    try {
      const res = await adminApi.delete(
        `/api/admin/orders/remove/${orderId}`
      );

      if (res.data.success) {
        refreshOrders(orderId); // <-- appel de la fonction passée en prop
      } else {
        setError("Suppression échouée : réponse inattendue");
      }
    } catch (err) {
      console.error("Erreur axios DELETE:", err.response || err);
      setError(err.response?.data?.message || "Erreur lors de la suppression");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DeleteButton onClick={handleDelete} disabled={loading}>
        {loading ? "Suppression..." : "Supprimer"}
      </DeleteButton>
      {error && <ErrorText>{error}</ErrorText>}
    </>
  );
}
